import { useTheme, useMediaQuery, Box, Typography } from "@mui/material";
import { Trans } from "@lingui/react/macro";

interface PrivacyPolicyProps {
  size: string;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ size }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const fontSize = isMobile ? "10px" : "min(max(0.35vw, 4px), 5px)";

  if (isMobile) {
    return (
      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          width: "100%",
          textAlign: "center",
          padding: 1,
          zIndex: 20,
        }}
      >
        <Typography
          variant="caption"
          sx={{
            color: "#a97d58",
            opacity: 0.9,
            fontFamily: "Arial, sans-serif",
            fontSize,
          }}
        >
          By using this service, you acknowledge you've read our{" "}
          <Typography
            variant="caption"
            sx={{
              color: theme.palette.primary.main,
              textDecoration: "underline",
              cursor: "pointer",
              fontSize,
            }}
            onClick={() => window.open("/policies/privacy-policy", "_blank")}
          >
            Privacy Policy
          </Typography>
          .
        </Typography>
      </Box>
    );
  }

  return (
    <svg
      className="curved-text-svg"
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: size,
        height: "100%",
        pointerEvents: "none",
        opacity: 0,
        visibility: "hidden",
        zIndex: 20,
      }}
      viewBox="0 0 400 400"
    >
      <defs>
        <path id="circle-path" d="M -7, 200 a 207,207 0 0,0 414,0" />
      </defs>
      <text
        fontSize={fontSize}
        fill="#a97d58"
        style={{ opacity: 0.9, fontFamily: "Arial, sans-serif" }}
      >
        <textPath href="#circle-path" startOffset="50%" textAnchor="middle">
          <Trans context="Privacy policy curved text on the circle">
            By using this service, you acknowledge you've read our{" "}
            <tspan
              fill={theme.palette.primary.main}
              style={{
                textDecoration: "underline",
                cursor: "pointer",
                pointerEvents: "auto",
              }}
              onClick={() => window.open("/policies/privacy-policy", "_blank")}
            >
              Privacy Policy
            </tspan>
            .
          </Trans>
        </textPath>
      </text>
    </svg>
  );
};

export default PrivacyPolicy;
